import { cn } from '@/utils/cn';

interface ShowAllButtonGlowProps {
  className?: string;
}

export function ShowAllButtonGlow({ className }: ShowAllButtonGlowProps) {
  return (
    <div className={cn('relative overflow-hidden rounded-[inherit] bg-c900', className)}>
      <div
        aria-hidden="true"
        className="absolute inset-0 rounded-[inherit] transition-opacity duration-300 group-hover:opacity-0"
        style={{
          background: [
            'radial-gradient(ellipse 55% 95% at 70% 17%, #4E256E 0%, rgba(78, 37, 110, 0) 100%)',
            'radial-gradient(ellipse 95% 85% at 14% 100%, #7C243D 0%, rgba(112, 31, 111, 0) 100%)',
          ].join(', '),
        }}
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 rounded-[inherit] opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{
          background: [
            'radial-gradient(ellipse 55% 120% at 70% 17%, #68269C 0%, rgba(109, 43, 161, 0) 100%)',
            'radial-gradient(ellipse 115% 105% at 14% 100%, #8D2140 0%, rgba(142, 36, 140, 0) 100%)',
          ].join(', '),
        }}
      />
    </div>
  );
}
